import { render, staticRenderFns } from "./ExtendAccount.vue?vue&type=template&id=a5c33e30&"
import script from "./ExtendAccount.vue?vue&type=script&lang=js&"
export * from "./ExtendAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports